<template>
  <BaseFormLayout
    :title="
      editMode
        ? `Edit ${configurationModule.project}`
        : `Add ${configurationModule.project}`
    "
    :nonFieldErrors="formErrors.non_field_errors"
    :isHeader="isHeader"
  >
    <template #actions>
      <SecondaryButton
        id="projectReset"
        v-if="!editMode"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="projectSubmit"
        v-if="!isHeader"
        @click="submitForm()"
        name="Submit & Add Another"
        btnClass="text-uppercase rounded-lg"
      >
      </PrimaryButton>
      <PrimaryButton
        id="projectSubmit"
        @click="submitForm()"
        name="Submit"
        :disabled="!isValid"
        btnClass="text-uppercase rounded-lg"
      >
      </PrimaryButton>
    </template>
    <template #content>
      <v-form
        v-model="isValid"
        ref="projectForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row class="h-100 ma-0 pa-0">
          <v-col cols="12" lg="4" class="pa-0 pr-lg-2">
            <v-card elevation="0" class="h-100 pa-0 rounded-lg">
              <v-row class="ma-0 pa-4">
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold"
                    >{{ configurationModule.branch }} Information</span
                  >
                </v-col>
                <v-col cols="12">
                  <SelectField
                    id="branch"
                    v-model="projectDetails.branch"
                    :label="`${configurationModule.branch}*`"
                    name="branch"
                    item-text="name"
                    item-value="id"
                    :disabled="editMode || isBranchDisable"
                    :items-list="branchList"
                    @change="getBranchDetail"
                    :rules="[
                      (val) =>
                        !!val || `${configurationModule.branch} is required`,
                    ]"
                    :error-messages="formErrors.branch"
                    @input="delete formErrors.branch"
                  />
                </v-col>
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold"
                    >{{ configurationModule.project }} Information</span
                  >
                </v-col>
                <v-col cols="12">
                  <InputField
                    id="name"
                    v-model="projectDetails.name"
                    name="name"
                    :label="`${configurationModule.project} Name`"
                    required
                    :error-messages="formErrors.name"
                    @input="delete formErrors.name"
                  />
                </v-col>
                <v-col cols="12">
                  <InputField
                    id="code"
                    v-model="projectDetails.code"
                    :label="`${configurationModule.project} Code`"
                    name="code"
                    required
                    :rules="[
                      (val) =>
                        (val && projectCodeValidation(val)) ||
                        'No special characters are allowed',
                      (val) =>
                        (val && val.length >= 2 && val.length <= 10) ||
                        `${configurationModule.project} Code should be between 2 to 10 Characters!`,
                    ]"
                    :error-messages="formErrors.code"
                    @input="delete formErrors.code"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" lg="8" class="pa-0 pl-2 pt-4 pt-lg-0 rounded-lg">
            <v-card elevation="0" class="rounded-lg">
              <GoogleMap
                mapId="projectMap"
                mapWidth="100%"
                mapHeight="calc(100vh - 170px)"
                ref="projectMap"
                :isDrawable="true"
                :showLocationName="true"
                :hasMapInfo="true"
              >
                <template #mapInfo>
                  <MapInfo legendType="branch" />
                </template>
              </GoogleMap>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </BaseFormLayout>
</template>

<script>
import { bus } from "@/main.js";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import { configurationModule } from "@/utils/moduleMapping";
import { projectCodeValidation } from "@/utils/functions";
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";

export default {
  components: {
    BaseFormLayout,
    BaseDialogForm,
    GoogleMap,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      required: true,
    },
    projectID: {
      type: Number,
    },
    isHeader: {
      type: Boolean,
      default: true,
    },
    isBranchDisable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      projectCodeValidation,
      configurationModule,
      fileInput: null,
      formCount: 0,
      isValid: true,
      projectDetails: {},
      branchDetails: {},
      formErrors: {},
      branchList: [],
      userDetails: this.$helper.getUserDetailsLocalStorage(),
    };
  },
  // watch: {
  //   value(val) {
  //     if (val && this.editMode) {
  //       this.getProjectObject();
  //     }
  //   },
  // },
  computed: {
    context() {
      return { parentComponent: this };
    },
    openProjectFormDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    resetForm() {
      this.projectDetails = {};
      this.$refs.projectForm.resetValidation();
      let inter = setInterval(() => {
        if (this.$refs.projectMap && this.$refs.projectMap.map) {
          clearInterval(inter);
          this.$refs.projectMap.deleteShape();
          this.$refs.projectMap.removeAllMarkers();
        }
      }, 100);
      setTimeout(() => {
        clearInterval(inter);
      }, 3000);
      if ("companyId" in this.$route.query) {
        this.projectDetails.company = this.$route.query.companyId;
      }
    },
    getBranchList() {
      let payload = {
        limit: "all",
      };
      if ("companyId" in this.$route.query) {
        payload.company = this.$route.query.companyId;
      }

      bus.$emit("showLoader", true);
      this.$api.branch
        .getBranchSelectList(payload)
        .then((res) => {
          this.branchList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch(() => {
          bus.$emit("showLoader", false);
        });
    },
    getBranchDetail(id) {
      if (id) {
        this.$api.branch
          .getBranchDetail(id)
          .then((res) => {
            this.branchDetails = res.data;
            if (
              this.branchDetails &&
              this.branchDetails.coordinates &&
              this.branchDetails.coordinates.coordinates &&
              this.branchDetails.coordinates.coordinates.length > 0
            ) {
              let position = {
                lat: this.branchDetails.coordinates.coordinates[1],
                lng: this.branchDetails.coordinates.coordinates[0],
              };
              this.$refs.projectMap.setMapCenter(position);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    getProjectObject(id) {
      this.$api.project
        .getProjectObject(id)
        .then((res) => {
          this.projectDetails = res.data;
          if (this.projectDetails && this.projectDetails.serviceable_area) {
            this.loadEditablePolygon();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadEditablePolygon() {
      let path = [];
      this.projectDetails.serviceable_area.coordinates[0].forEach((element) => {
        path.push({ lat: element[1], lng: element[0] });
      });

      let inter = setInterval(() => {
        if (this.$refs.projectMap && this.$refs.projectMap.map) {
          clearInterval(inter);

          this.$refs.projectMap.setMapZoom(9);
          this.$refs.projectMap.setEditablePolygon(
            path,
            this.projectDetails.serviceable_area.coordinates[0]
          );
        }
      });
    },
    submitForm() {
      if (!this.$refs.projectForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      let data = { ...this.projectDetails };

      let geoJSON = this.$refs.projectMap.convertToGeoJSON();
      data.serviceable_area = geoJSON ? geoJSON.geometry : null;

      if (this.editMode) {
        this.$api.project
          .updateProjectObject({
            id: this.projectDetails.id,
            data: data,
          })
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Project information updated!",
              color: "success",
            });
            this.$emit("refreshList");
            this.resetForm();
            this.$router.push({ name: "project-list" });
          })
          .catch((err) => {
            if (err.data) {
              this.formErrors = err.data;
            }
          });
      } else {
        this.$api.project
          .createProjectObject(data)
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Project created!",
              color: "success",
            });
            this.resetForm();
            if (!this.isHeader) {
              this.$emit("redirect", true);
            } else {
              this.$router.push({ name: "project-list" });
            }
          })
          .catch((err) => {
            if (err.data) {
              this.formErrors = err.data;
            }
          });
      }
    },
  },
  mounted() {
    this.getBranchList();
    if ("companyId" in this.$route.query) {
      this.projectDetails.company = this.$route.query.companyId;
    }
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.getProjectObject(this.$route.params.id);
    }
    let inter = setInterval(() => {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (!this.editMode && obj.preferred_branch && obj.preferred_branch.id) {
        clearInterval(inter);
        this.projectDetails = {
          branch: obj.preferred_branch.id,
        };
      }
    }, 200);
  },
};
</script>

<style>
.v-select__slot label {
  z-index: 2;
}
</style>
